import { useDataTableContext } from "@msuite/ui/table";
import type { FileCollectionTable, Tables } from "@msuite/utils/types";
import { RemoteFileInspector } from "@/components/files";
import type { FileParent } from "@msuite/citadel";

/** Props Interface */
interface RowFilesUnlinkConfig {
	tableName: FileCollectionTable;
	foreignKey: string;
	identifier: string;
}

interface RowFilesProps {
	files: Array<
		{
			id: string;
		} & {
			file: Tables<"files">;
		}
	>;
	unlink: RowFilesUnlinkConfig;
	/** The row the files hang on, which every write the cell offers is asked of. */
	parent: FileParent;
}

export function RowFiles({ files, unlink, parent }: RowFilesProps) {
	const { refetch } = useDataTableContext();

	/** Functions */
	function handleOnFilesChanged() {
		refetch?.();
	}

	/** Render */
	return (
		<RemoteFileInspector
			itemFiles={files || []}
			tableName={unlink.tableName}
			foreignKey={unlink.foreignKey}
			identifier={unlink.identifier}
			parent={parent}
			withUpload
			onInteraction={handleOnFilesChanged}
			onUnlinked={handleOnFilesChanged}
			onLinked={handleOnFilesChanged}
		/>
	);
}
